const { createElem, isValidEmail } = require('./helpers');
const imgSrc = require('../assets/images/icon-tile-heart.svg');
const imgAltSrc = require('../assets/images/icon-tile-party.svg');

class SubscribeTile {
  constructor(layout) {
    this.heading = window.obData.newsletterSettings.headingText;
    this.subheading = window.obData.newsletterSettings.subheadingText;
    this.img = imgSrc;
    this.imgAlt = imgAltSrc;
    this.puppetCta = null;
    this.layout = layout;
  }

  handleFormPuppet(email) {
    const activateTrigger = this.puppetCta.querySelector('.cta-activate-button-container input');
    activateTrigger.focus();

    setTimeout(() => {
      const puppetInput = this.puppetCta.querySelector(
        '.form-fields .cta-field-section.email-field input'
      );
      // const
      const submitTrigger = this.puppetCta.querySelector('input[type="submit"]');

      puppetInput.value = email;
      submitTrigger.click();
    }, 500);
  }

  handleSubmit(e) {
    e.preventDefault();

    const formElem = e.currentTarget;
    const email = formElem.querySelector('input').value;

    if (!isValidEmail(email)) {
      formElem.classList.add('-error');
      return;
    }

    formElem.classList.remove('-error');
    formElem.classList.add('-success');
    this.handleFormPuppet(email);
  }

  buildHtml() {
    const frag = document.createDocumentFragment();

    const tileElem = createElem('div', { class: 'sub-tile' });
    const tileWrapper = createElem('div', { class: 'sub-tile--wrapper' });
    const tileContent = createElem('div', { class: 'sub-tile--content' });
    const imgElem = createElem('img', { src: this.img, alt: '' });
    const imgAltElem = createElem('img', { src: this.imgAlt, alt: '' });
    const headingElem = createElem('h4', { class: 'sub-tile--heading' }, this.heading);
    const subheadingElem = createElem('p', { class: 'sub-tile--subheading' }, this.subheading);
    const inputWrapper = createElem('div', { class: 'sub-tile--input-wrapper' });
    const form = createElem('form');
    const label = createElem(
      'label',
      { class: 'visually-hidden', for: 'email-signup' },
      'Your email address'
    );
    const input = createElem('input', {
      type: 'text',
      class: 'sub-tile--input_text',
      name: 'email-signup',
      placeholder: 'Your email address',
    });
    const submit = createElem('button', { type: 'submit', class: 'sub-tile--button' }, 'Subscribe');
    const errorText = createElem(
      'span',
      { class: 'sub-tile--error-text' },
      'Please correct your email address'
    );
    const successMessage = createElem(
      'span',
      { class: 'sub-tile--success-text' },
      'Thanks for subscribing!'
    );

    form.addEventListener('submit', (e) => this.handleSubmit(e));

    frag.appendChild(tileElem);
    tileElem.appendChild(tileWrapper);
    tileWrapper.appendChild(imgElem);
    tileWrapper.appendChild(imgAltElem);
    tileWrapper.appendChild(tileContent);
    tileContent.appendChild(headingElem);
    tileContent.appendChild(subheadingElem);
    inputWrapper.appendChild(form);
    form.appendChild(label);
    form.appendChild(input);
    form.appendChild(submit);
    form.appendChild(errorText);
    form.appendChild(successMessage);
    tileWrapper.appendChild(inputWrapper);

    return frag;
  }

  moveCta() {
    const target = document.getElementById('collection-items');
    target.appendChild(this.puppetCta);
    this.puppetCta.style.display = 'none';
  }

  hasCta() {
    const { subCtaId } = window.obData.newsletterSettings;
    const targetCta = document.querySelector(`#hub-cta-${subCtaId}`);

    if (!targetCta) {
      return false;
    }

    this.puppetCta = targetCta;
    this.moveCta();
    return true;
  }

  appendSubTile() {
    let targets = [document.querySelector('.tile:nth-of-type(3)')];

    if (this.layout === 'three-col-layout') {
      targets = [...targets, document.querySelector('.tile:nth-of-type(7)')];
    } else {
      targets = [...targets, document.querySelector('.tile:nth-of-type(5)')];
    }

    if (targets[0]) {
      targets[0].parentNode.insertBefore(this.buildHtml(), targets[0].nextSibling);
    }

    if (targets[1]) {
      targets[1].parentNode.insertBefore(this.buildHtml(), targets[1].nextSibling);
    }
  }

  init() {
    this.hasCta() ? this.appendSubTile() : null;

    return this;
  }
}

module.exports = SubscribeTile;



// WEBPACK FOOTER //
// ./modules/SubscribeTile.js